let id = 0;
export default () => {
	return id++;
};
